import { render, staticRenderFns } from "./number-unit.vue?vue&type=template&id=ed7478dc&scoped=true&"
import script from "./number-unit.vue?vue&type=script&lang=ts&"
export * from "./number-unit.vue?vue&type=script&lang=ts&"
import style0 from "./number-unit.vue?vue&type=style&index=0&id=ed7478dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7478dc",
  null
  
)

export default component.exports